<template lang="pug">
.validacao-component
    .acoes(v-if='!validarOuVisualizarAnalise')
        radio-button-component(
            ref='validacaoCheckbox'
            v-model='item.aprovado',
            :list='aprovadoOptions',
            @input='checkCondicao',
            :class='"--" + tipo'
            :disabled='validarOuVisualizarAnalise'
        ).radio-position
    .visualizacaoGO(v-else)
        chip-component(
            border-color='transparent',
            :background-color='item.aprovado === "APROVADO"? "var(--primary-light-green)" : "var(--primary-light-red)"',
            :color='"var(--primary-white)"',
            :label='item.aprovado === "APROVADO"? "Aprovado" : "Reprovado"',
            border-radius='5px',
            width='150px'
        )
    .reprovado-acoes(v-if='item.aprovado === "REPROVADO"')
        chip-component(
            border-color='transparent',
            background-color='transparent',
            icon='mdi-magnify'
            color='var(--primary-black)',
            @click.native='visualizarReprovacao(item)'
        ).chip-visualizar
        chip-component(
            v-if='!validarOuVisualizarAnalise'
            border-color='transparent',
            background-color='transparent',
            icon='mdi-pencil-outline'
            color='#006fb9',
            @click.native='editarReprovacao(item)'
        ).chip-editar

    modal-component(v-if='modalValidacao', title='Reprovar', width='35rem', @close='cancelarModal()')
        .modal-validacao
            .modal-content
                .linha
                    b Tipo:
                    div(style='padding-left: 3px') {{ tipo }}
                .linha
                    .coluna
                        .justificativa(:class='touch.justificativa ? "--touch" : ""')
                            text-area-input-component(v-model='validacao.justificativa', label='Justificativa*:')
                .linha
                    .coluna
                        .solicitar(:class='touch.solicitar ? "--touch" : ""')
                            checkbox-group-input-component(v-model='selecionados', label='Solicitar:', :list='checkboxes')
                            grid-table-component(
                                v-if='checkboxes[2].selecionado',
                                :headers='headers',
                                :data='tiposDocumentosDisponiveis',
                                :is-paginated='false'
                                :custom='tableStyle'
                            )
                                template(v-slot:selecionado='{ item }')
                                    checkbox-input-component(v-model='item')

            .modal-footer(:style='[ { display: "flex" },  { justifyContent: "space-between" }, { marginTop: "30px" } ]')
                button-component(
                    label='Cancelar',
                    icon='mdi-close',
                    background-color='var(--primary-gray)',
                    color='var(--primary-light-smoke)',
                    @click.native='cancelarModal()'
                )
                button-component(icon='mdi-check', label='Confirmar', @click.native='reprovar')

    modal-component(v-if='modalVisualizacaoValidacao', title='Avaliação reprovada', width='35rem', @close='modalVisualizacaoValidacao = false')
        VisualizacaoValidacaoModal(:item='itemSelecionado')

</template>

<script>
import VisualizacaoValidacaoModal from '@/views/analise/components/VisualizacaoValidacaoModal.vue';

import { CondicaoEnum, CondicaoValidacaoEnum } from '@/enums/processo.enum';
import { Perfil } from '@/utils/constants.utils.js';

export default {
    name: 'ValidacaoComponent',

    components: {
        VisualizacaoValidacaoModal
    },

    props: {
        tipo: {
            type: String,
            required: true,
        },
        item: {
            type: Object,
            required: true,
        },
        tiposDocumentos: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {

            tiposDocumentosDisponiveis: null,

            aprovadoOptions: [],

            selecionados: [],

            checkboxes: [
                { id: 1, nome: 'Retificação da proposta', selecionado: false },
                { id: 3, nome: 'Retificação do cadastro do imóvel', selecionado: false },
                { id: 2, nome: 'Documentos', selecionado: false },
            ],

            modalValidacao: false,

            validacao: {},

            headers: [
                { text: '', field: 'selecionado', width: '20px' },
                { text: 'Tipo de documento', field: 'nome' },
                { text: 'Descrição', field: 'descricao' },
            ],

            touch: {
                justificativa: false,
                solicitar: false
            },

            modalVisualizacaoValidacao: false,
            isEditingAvaliacao: false,
            itemSelecionado: null,
            tableStyle: `
                height: 300px;
                overflow-y: scroll;
                border-radius: 5px;
                border-top: 0.3px solid var(--primary-dark-smoke);
                border-bottom: 0.3px solid var(--primary-dark-smoke);
            `
        };
    },

    computed: {
        validarOuVisualizarAnalise() {
            return this.$eu().perfil === Perfil.GERENTE_OPERACIONAL ||
                this.$route.params.condicao === CondicaoEnum.AGUARDANDO_VALIDACAO_ANALISE.id;
        }
    },

    mounted() {
        this.setAprovadoOptions();
        this.verificarDocumentosSolicitados(this.item);
    },

    methods: {

        setAprovadoOptions() {
            this.aprovadoOptions = [
                { id: 'APROVADO', label: 'Aprovado', checked: this.item.aprovado === 'APROVADO' },
                { id: 'REPROVADO', label: 'Reprovado', checked: this.item.aprovado === 'REPROVADO' },
            ]
        },
        montarDocumentosDisponiveis() {
            this.tiposDocumentosDisponiveis = this.tiposDocumentos.map((documentoSolicitacao) => {
                return { ...documentoSolicitacao };
            });
        },

        aprovar() {
            this.validacao = {};
            this.validacao.condicao = CondicaoValidacaoEnum.APROVADO.id;
            this.item.justificativa = '';
            this.item.retificacaoSolicitada = false;
            this.item.retificacaoImovel = false;
            this.item.documentosSolicitados = [];

            this.checkboxes[0].selecionado = false;
            this.checkboxes[1].selecionado = false;
            this.checkboxes[2].selecionado = false;

            this.$emit('validacao', this.validacao);
        },

        reprovar() {
            this.validacao.condicao = CondicaoValidacaoEnum.REPROVADO.id;
            this.validacao.documentos = [];
            this.validacao.documentos = this.tiposDocumentosDisponiveis
                .filter(doc => doc.selecionado)
                .map(doc => ({ id: doc.id, nome: doc.nome, descricao: doc.descricao }));

            this.item.documentosSolicitados = this.validacao.documentos;

            if (!this.isValid()) {
                this.$toast({
                    showClose: true,
                    message: 'Campos obrigatórios devem estrar preenchidos!',
                    type: 'error'
                });
                return;
            }

            this.item.justificativa = this.validacao?.justificativa;
            this.item.retificacaoSolicitada = this.checkboxes[0].selecionado;
            this.item.retificacaoImovel = this.checkboxes[1].selecionado;

            if (!this.checkboxes[2].selecionado) {
                this.validacao.documentos = [];
                this.item.documentosSolicitados = [];
            }
            this.$emit('validacao', this.validacao);
            this.modalValidacao = false;
        },

        cancelarModal() {
            if (this.isEditingAvaliacao) {
                this.reprovar();
            } else {
                this.item.aprovado = 'APROVADO';
                this.validacao = {};
                this.checkboxes[0].selecionado = false;
                this.checkboxes[1].selecionado = false;
                this.checkboxes[2].selecionado = false;
                this.setAprovadoOptions();
                this.$refs.validacaoCheckbox.$forceUpdate();
                this.modalValidacao = false;
            }
            this.isEditingAvaliacao = false;
        },

        checkCondicao() {
            if (this.item.aprovado === 'REPROVADO') {
                this.resetTouch();
                this.modalValidacao = true;
                this.verificarDocumentosSolicitados(this.item);
            }
            if (this.item.aprovado === 'APROVADO') {
                this.aprovar();
            }
            this.setAprovadoOptions();
            this.$refs.validacaoCheckbox.$forceUpdate()
        },

        isValid() {
            this.resetTouch();

            let valid = true;

            if (!this.validacao.justificativa) {
                this.touch.justificativa = true;
                valid = false;
            } else this.touch.justificativa = false;

            if ((this.checkboxes[0].selecionado === false && this.checkboxes[1].selecionado === false && this.checkboxes[2].selecionado === false) ||
                (this.checkboxes[2].selecionado === true && this.validacao.documentos?.length === 0)) {
                this.touch.solicitar = true;
                valid = false;
            } else {
                this.touch.solicitar = false;
            }

            return valid;
        },

        visualizarReprovacao(item) {
            this.itemSelecionado = {
                justificativa: item.justificativa,
                retificacaoSolicitada: item.retificacaoSolicitada,
                retificacaoImovel: item.retificacaoImovel,
                documentos: this.item.documentosSolicitados,
            }
            this.modalVisualizacaoValidacao = true;
        },

        editarReprovacao(item) {
            this.isEditingAvaliacao = true;
            this.modalValidacao = true;
            this.validacao = {
                tipo: item.tipo,
                justificativa: item.justificativa,
                condicao: item.condicao,
            };
            this.checkboxes[0].selecionado = item.retificacaoSolicitada;
            this.checkboxes[1].selecionado = item.retificacaoImovel;

            this.verificarDocumentosSolicitados(item);
        },

        resetTouch() {
            this.touch = {
                justificativa: false,
                solicitar: false
            }
        },

        verificarDocumentosSolicitados(item) {
            this.montarDocumentosDisponiveis();
            const documentosSolicitados = item.documentosSolicitados || [];
            this.checkboxes[2].selecionado = documentosSolicitados.length > 0;

            for (const doc of documentosSolicitados) {
                this.tiposDocumentosDisponiveis = this.tiposDocumentosDisponiveis.map(tipoDoc => {
                    if (tipoDoc.id === doc.id) {
                        // Usando Vue.set para garantir que as mudanças sejam reativas
                        this.$set(tipoDoc, 'selecionado', true);
                    }
                    return tipoDoc;
                });
            }
        }

    },
};
</script>

<style lang="scss" scoped>
.acoes {
    display: flex;
    justify-content: flex-start;

    // button:last-child,
    // div:last-child {
    //     margin-left: 20px;
    // }
}

.validacao-component {
    display: flex;
}

.visualizacaoGO {
    display: flex;
    align-items: flex-end;
}

.reprovado-acoes {
    display: flex;
    align-items: flex-end;
}

.chip-visualizar:hover {
    cursor: pointer;
}

.chip-editar:hover {
    cursor: pointer;
    background-color: var(--primary-light-blue);
}

.justificativa {
    padding: 5px;
}

.solicitar {
    padding: 5px;
}

.--touch {
    border: 2px solid var(--primary-light-red) !important;
    border-radius: 5px !important;
}
</style>
